import { ArrowBottomRightThickIcon } from './ArrowBottomRightThickIcon';

/**
 * author: Michael Irigoyen
 * id 01AD77CD-8F92-4E32-A752-387203BC9FF8
 * name arrow-bottom-right-thick
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomRightBoldIcon = ArrowBottomRightThickIcon;
export default ArrowBottomRightBoldIcon